var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResponseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 43239"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.4287 10L15.4186 11.0101L17.2624 12.8571H11.4287C10.6709 12.8571 9.94419 13.1582 9.40837 13.694C8.87255 14.2298 8.57153 14.9565 8.57153 15.7143C8.57153 16.472 8.87255 17.1988 9.40837 17.7346C9.94419 18.2704 10.6709 18.5714 11.4287 18.5714H12.8572V17.1429H11.4287C11.0498 17.1429 10.6864 16.9923 10.4185 16.7244C10.1506 16.4565 10.0001 16.0932 10.0001 15.7143C10.0001 15.3354 10.1506 14.972 10.4185 14.7041C10.6864 14.4362 11.0498 14.2857 11.4287 14.2857H17.2624L15.4176 16.1339L16.4287 17.1429L20.0001 13.5714L16.4287 10Z",
    fill: "#1B224C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.71429 12.8571H1.42857L1.42614 2.076L9.59336 7.73021C9.71286 7.81287 9.8547 7.85714 10 7.85714C10.1453 7.85714 10.2871 7.81287 10.4066 7.73021L18.5714 2.07757V8.57143H20V1.42857C19.9995 1.04984 19.8489 0.686748 19.5811 0.418941C19.3133 0.151134 18.9502 0.000472534 18.5714 0H1.42857C1.05012 -5.79497e-07 0.687139 0.150166 0.419302 0.417535C0.151464 0.684903 0.000662284 1.04762 0 1.42607V12.8571C0.000491391 13.2359 0.151159 13.599 0.418962 13.8668C0.686764 14.1346 1.04984 14.2852 1.42857 14.2857H5.71429V12.8571ZM16.999 1.42857L10 6.27407L3.001 1.42857H16.999Z",
    fill: "#1B224C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResponseIcon);
export default __webpack_public_path__ + "static/media/responseIcon.deccb85dcfe1b692bb2c9dad8ca4051e.svg";
export { ForwardRef as ReactComponent };